// Mutable shared environment state, updated by <Environment/> each frame and
// read by buildings for night window illumination. Avoids React re-renders.
export const envState = {
  night: 0, // 0 day -> 1 night
  sunlight: 1, // directional light factor (reduced by rain/snow)
};
